/**
 * The feed's sport code as a word — `football` → "Football".
 *
 * The code is `external_metadata ->> 'classSortRef'`, and title-casing it is
 * what the catalogue's fixture list and outcome picker have always done. Kept
 * as a formatter rather than improved into a lookup against the `sports` table:
 * that would read better for the two sports we configure and worse for every
 * other one the feed carries, and screens naming the same sport two ways is the
 * one outcome worth avoiding.
 *
 * `null` in, `null` out — a missing sport is a dash on one screen, a dropped
 * clause on another, so the caller decides.
 */
export const formatSportLabel = (code: string | null): string | null => {
  if (!code) return null;

  return code
    .replace(/_/g, ' ')
    .split(/\s+/)
    .map((word) =>
      word.length === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
    )
    .join(' ');
};
